// extracted by mini-css-extract-plugin
export default {"container":"subjects_container__xWhhG","newSubjectsContainer":"subjects_newSubjectsContainer__4Ow++"};